import { render, staticRenderFns } from "./collection-movements.vue?vue&type=template&id=b08dff70"
import script from "./collection-movements.vue?vue&type=script&lang=js"
export * from "./collection-movements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b08dff70')) {
      api.createRecord('b08dff70', component.options)
    } else {
      api.reload('b08dff70', component.options)
    }
    module.hot.accept("./collection-movements.vue?vue&type=template&id=b08dff70", function () {
      api.rerender('b08dff70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/CustomerViews/Collections/collection-movements.vue"
export default component.exports